import AttributesCollection from './core/AttributeCollection';
import Attribute from './core/Attribute';
import Model from './Model';
import ModelAttribute from './core/ModelAttribute';
import Sector from './Sector';

export default class UserSectorArea extends Model {
  public userId: number;
  public sectorId: number;
  public quartier: string;
  public sector: Sector;

  static readonly modelUrl = "user_sector_areas";
  public modelName = "userSectorArea";

  public attributes = new AttributesCollection({
    userId: new Attribute("userId"),
    sectorId: new Attribute("sectorId"),
    quartier: new Attribute("quartier"),
    sector: new ModelAttribute("sector", Sector, { submittable: false }),
  });

  constructor(json) {
    super(json);
    this.fillAttributes(json);
  }
}
